<template>
  <div>
    <main class="main product-details-main ">
      <PagesPath
        v-if="blog != null"
        :pathTitle1="'پست ها'"
        :pathTo1="'/weblog-list'"
        :pathTitle2="blog != null ? blog.post.title : ''"
      ></PagesPath>
      <div class="weblog-details-grid    text-right mt-md-5 mt-3">
        <div class="weblog-list-main w-100 mb-md-5 mb-4">
          <section class="weblog-details  py-4 mb-5">
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <h1 v-else class=" title-blog main-container">
              {{ blog.post.title }}
            </h1>
            <hr class="main-container" />
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <div
              v-else
              class="d-flex main-container flex-wrap justify-content-around align-items-baseline mb-3"
            >
              <div class="weblog-item-publisher d-flex align-items-baseline">
                <div class="article-user-img ml-1">
                  <!-- <img :src="blog.post.image.url" alt=""> -->
                </div>
                <span class="text-color-666 fontsize-small weight-bold">{{
                  blog.post.creatorable.name
                }}</span>
              </div>
              <div class="weblog-list-post-date">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 22.0001C6.48 22.0001 2 17.5301 2 12.0001C2 6.48011 6.48 2.00011 12 2.00011C17.53 2.00011 22 6.48011 22 12.0001C22 17.5301 17.53 22.0001 12 22.0001ZM15.19 15.7101C15.31 15.7801 15.44 15.8201 15.58 15.8201C15.83 15.8201 16.08 15.6901 16.22 15.4501C16.43 15.1001 16.32 14.6401 15.96 14.4201L12.4 12.3001V7.68011C12.4 7.26011 12.06 6.93011 11.65 6.93011C11.24 6.93011 10.9 7.26011 10.9 7.68011V12.7301C10.9 12.9901 11.04 13.2301 11.27 13.3701L15.19 15.7101Z"
                    fill="#999"
                  />
                </svg>
                <span
                  class="haederBlogDetail fontsize-small text-color-666 weight-bold pr-1"
                  >تاریخ انتشار :</span
                >
                <span class="fontsize-small text-color-999">{{
                  blog.post.published_at | Date
                }}</span>
              </div>
              <div class="fontsize-small weblog-list-post-date">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12ZM17.7366 6.04606C19.4439 7.36485 20.8976 9.29455 21.9415 11.7091C22.0195 11.8933 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8933 2.05854 11.7091C4.14634 6.88 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM12.0012 14.4124C13.3378 14.4124 14.4304 13.3264 14.4304 11.9979C14.4304 10.6597 13.3378 9.57362 12.0012 9.57362C11.8841 9.57362 11.767 9.58332 11.6597 9.60272C11.6207 10.6694 10.7426 11.5227 9.65971 11.5227H9.61093C9.58166 11.6779 9.56215 11.833 9.56215 11.9979C9.56215 13.3264 10.6548 14.4124 12.0012 14.4124Z"
                    fill="#999"
                  />
                </svg>
                <span
                  class="haederBlogDetail  text-color-666 weight-bold pr-1"
                  >{{ blog.post.view_count }}</span
                >
                <span class="text-color-999">بازدید</span>
              </div>
              <div class="fontsize-small weblog-list-post-date">
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M2 12.015C2 6.74712 6.21 2 12.02 2C17.7 2 22 6.65699 22 11.985C22 18.1642 16.96 22 12 22C10.36 22 8.54 21.5593 7.08 20.698C6.57 20.3876 6.14 20.1572 5.59 20.3375L3.57 20.9384C3.06 21.0986 2.6 20.698 2.75 20.1572L3.42 17.9139C3.53 17.6034 3.51 17.2729 3.35 17.0125C2.49 15.4301 2 13.6975 2 12.015ZM10.7 12.015C10.7 12.7261 11.27 13.2969 11.98 13.307C12.69 13.307 13.26 12.7261 13.26 12.025C13.26 11.314 12.69 10.7431 11.98 10.7431C11.28 10.7331 10.7 11.314 10.7 12.015ZM15.31 12.025C15.31 12.7261 15.88 13.307 16.59 13.307C17.3 13.307 17.87 12.7261 17.87 12.025C17.87 11.314 17.3 10.7431 16.59 10.7431C15.88 10.7431 15.31 11.314 15.31 12.025ZM7.37 13.307C6.67 13.307 6.09 12.7261 6.09 12.025C6.09 11.314 6.66 10.7431 7.37 10.7431C8.08 10.7431 8.65 11.314 8.65 12.025C8.65 12.7261 8.08 13.2969 7.37 13.307Z"
                    fill="#999"
                  />
                </svg>
                <span
                  v-if="blog.post.comments.length != 0"
                  class="text-color-666 weight-bold"
                  >{{ blog.post.comments.length }}</span
                >
                <span v-else class="text-color-666 weight-bold pr-1">0</span>
                <span class=" haederBlogDetail text-color-999 pr-1"
                  >دیدگاه</span
                >
              </div>
            </div>
            <hr class="main-container" />
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
            <figure class="m-0 image-main" v-else>
              <img
                v-if="blog.post.image != null"
                :src="blog.post.image.url"
                :alt="blog.post.title"
                class="articleImage"
              />
            </figure>
            <br v-if="blogStatus" />
            <h5 v-else class="text-color-444 main-container mt-5 mb-4">
              {{ blog.post.summary }}
            </h5>
            <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
            <div
              v-else
              class="dis-post main-container"
              v-html="blog.post.body"
            ></div>
            <!-- <hr />
            <div class="d-flex justify-content-between">
              <span class="fontsize14 weight-bold ml-3 flex-shrink-0">برچسب ها:</span>
              <div  class="fontsize12 text-color-999">
                <span>#لباس</span>
                <span>#کفش</span>
                <span>#لباس-گرم</span>
                <span>#لباس-تابستانی</span>
                <span>#لباس</span>
                <span>#کفش</span>
                <span>#لباس-گرم</span>
                <span>#لباس-تابستانی</span>
              </div>
            </div> -->
            <hr />
            <b-skeleton v-if="blogStatus"></b-skeleton>
            <div v-else class="d-flex main-container justify-content-between">
              <span class="fontsize-small weight-bold ml-3"
                >اشتراک گذاری مطلب :</span
              >
              <section class="sotial-networks">
                <!-- :href="
                    'whatsapp://send?text=' + encodeURIComponent(getBlogLink())
                  " -->
                <a
                  :href="
                    'whatsapp://send?text=' + encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <whatsapp />
                </a>

                <a
                  :href="
                    'http://twitter.com/share?url=' +
                      encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <twitter />
                </a>

                <a
                  :href="
                    `https://t.me/share/url=` +
                      encodeURIComponent(getBlogLink())
                  "
                  class="mx-2"
                >
                  <telegram />
                </a>
              </section>
            </div>
          </section>
          <b-skeleton v-if="blogStatus"></b-skeleton>
          <section
            v-else-if="blog && blog.suggests != ''"
            class="similar-articles main-container"
          >
            <div
              class="d-flex justify-content-between align-items-baseline  mb-3"
            >
              <h5 class="fontsize-heavy">مطالب مشابه</h5>
              <router-link
                class="recommended-products-more fontsize-small text-white bg-color-a5
                 px-3 py-2 mt-3 d-inline-block"
                to="/weblog-list"
                >مشاهده همه پست ها
              </router-link>
            </div>

            <section class="weblog-list-main-grid">
              <!-- افزودن پست های پیشنهادی با ارسال داده به صورت پراپس -->
              <!-- <Weblog
                v-for="(suggest, index) in blog.suggests"
                :key="'suggest' + index"
                :weblog="suggest"
              ></Weblog> -->
              <postCard
                class="w-100"
                v-for="(blog, index) in blog.suggests"
                :key="'suggest' + index"
                :blog="blog"
              />
            </section>
          </section>
          <div class="main-container">
            <CommentSection />
          </div>
        </div>
        <!-- <div class="welog-list-side w-100">
          <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
          <br v-if="blogStatus" />

          <section v-else class="weblog-categories    p-3 bg-white mb-3">
            <div class="d-flex border-bottom-dashed pb-2">
              <h6 class="mr-2 weight-bold text-color-444 fontsize-medium">
                دسته بندی ها
              </h6>
            </div>
            <ul class="py-3">
              <li v-for="(category, index) in blog.category" :key="'category' + index">
                <router-link class="fontsize-small" :to="{
                  name: 'weblogList',
                  params: { id: category.id, slug: getSlug(category) },
                }">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor"
                    class="bi bi-chevron-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                  </svg>
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </section>
          <b-skeleton-img v-if="blogStatus"></b-skeleton-img>
          <section v-else-if="blog && blog.lastPost != ''"
            class="weblog-last-articles   box-shaddow20 p-3 bg-white mb-3">
            <div class="d-flex border-bottom-dashed pb-2 mb-3">
              <h5 class="mr-2 fontsize-medium weight-bold text-color-444">
                آخرین مطالب
              </h5>
            </div>
            <article v-for="(post, index) in blog.lastPost" :key="'post' + index">
              <router-link class="d-flex mb-3 fontsize-small" :to="{
                name: 'blogDetail',
                params: { id: post.id, slug: post.slug },
              }">
                <div class="weblog-last-articles-img ml-1 ">
                  <img v-if="post.image" :src="post.image.url" alt="" />
                  <img v-else src="../../../assets/images/blog.jpg" alt="blog" />
                </div>
                <div class="d-flex flex-column w-100 justify-content-center">
                  <h6 class="fontsize15 text-color-666">
                    {{ post.title.substr(0, 40) }}
                    {{ post.title.length > 40 ? "..." : "" }}
                  </h6>
                  <div class="d-flex justify-content-between align-items-baseline">
                    <span class="fontsize-mini text-color-999">{{
                      post.created_at | Date
                    }}</span>
                    <button class="mr5 fontsize-mini pr-1 text-color-theme bg-none">
                      اطلاعات بیشتر ...
                    </button>
                  </div>
                </div>
              </router-link>
            </article>
          </section>
        </div> -->
      </div>

      <ScrollToTop></ScrollToTop>
      <FooterButtons></FooterButtons>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import telegram from "@/parts/Front/components/icons/telegram.vue";
import whatsapp from "@/parts/Front/components/icons/whatsapp.vue";
import twitter from "@/parts/Front/components/icons/twitter.vue";
import ScrollToTop from "@/parts/Front/components/ScrollToTop";
import FooterButtons from "@/parts/Front/components/FooterButtons";
import PagesPath from "@/parts/Front/components/PagesPath";
// import Weblog from "@/parts/Front/components/Weblog";
import CommentSection from "@/parts/Front/components/weblog/CommentSection";
import { BSkeleton, BSkeletonImg } from "bootstrap-vue";
import config from "../../../config";
import postCard from "../components/postCard.vue";
import Twitter from "../nicecomponents/svgs/Twitter.vue";
import Whatsapp from "../nicecomponents/svgs/Whatsapp.vue";
export default {
  name: "WblogDetails",
  components: {
    twitter,
    whatsapp,
    telegram,
    CommentSection,
    ScrollToTop,
    FooterButtons,
    PagesPath,
    // Weblog,
    postCard,
    BSkeleton,
    BSkeletonImg,
    Twitter,
    Whatsapp,
  },
  beforeCreate() {
    this.$store.dispatch(
      "front/getBlogDetailFromServer",
      this.$route.params.id
    );
  },
  computed: {
    blog() {
      return this.$store.getters["front/getBlogDetail"];
    },
    blogTitlePage() {
      if (this.$store.getters["front/getBlogDetail"] != null) {
        let blog = this.$store.getters["front/getBlogDetail"].post;

        return blog.title_page ? blog.title_page : blog.title;
      } else {
        return null;
      }
    },
    blogMetaDescription() {
      if (this.$store.getters["front/getBlogDetail"] != null) {
        let blog = this.$store.getters["front/getBlogDetail"].post;

        return blog.meta_description;
      } else {
        return null;
      }
    },
    blogStatus() {
      return this.$store.getters["front/getBlogDetailStatus"];
    },
  },
  data() {
    return {};
  },
  methods: {
    getSlug(item) {
      let Text = item.slug ? item.slug : item.name;
      return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },

    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getBlogLink() {
      // گرفتن لینک این بلاگ برای اشتراک گزاری
      if (!this.blog.post) {
        return "";
      }
      return (
        window.location.hostname +
        "/blogs/" +
        this.blog.post.id +
        "/" +
        this.blog.post.slug
      );
    },

    // تابع زیر برای اضافه کردن متا تگ و بالا بردن سئو است
  },
  mounted() {
    // در صورتی که کابر لاگین کرده بود و ایمیل داشت مقدار پیشفرض ایمیل را همان مفدار نشان بده
    if (this.$store.getters["front/getHomeData"] != null) {
      if (this.$store.getters["front/getHomeData"].user.user != false) {
        if (this.$store.getters["front/getHomeData"].user.user.email != null) {
          this.email = this.$store.getters["front/getHomeData"].user.user.email;
        }
      }
    }
  },
  metaInfo() {
    return {
      title: this.blogTitlePage,
      meta: [
        {
          name: "description",
          content: this.blogMetaDescription,
        },
        {
          property: "og:title",
          content: this.blogTitlePage,
        },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
};
</script>

<style scoped>
.weblog-list-main-grid {
  grid-template-columns: repeat(4, 1fr);
}
.title-blog {
  font-size: 2rem;
  color: #000;
}

.weblog-categories {
  position: sticky;
  top: 10px;
}

.weblog-details-grid {
  /*display: grid;
  grid-template-columns: calc(100% - 380px) 350px;
  grid-gap: 20px 30px;*/
}

.inputAlert {
  background-color: rgb(255 250 244);
}

.image-main {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* افزودن استایل به کدهای اضافی قالب */
.articleImage {
  width: 88%;
  margin-inline: auto;
}

.haederBlogDetail {
  margin-left: 5px;
}

.mr5 {
  margin-right: 5px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.weblog-details >>> img {
  max-width: 100%;
}

@media screen and (max-width: 1200px) {
  .weblog-details-grid {
    /* display: grid;
    grid-template-columns: 100%;
    grid-gap: 20px 30px;*/
  }
  .weblog-list-main-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 648px) {
  .weblog-list-main-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 550px) {
  .title-blog {
    font-size: 20px;
  }

  .articleImage {
    width: 100%;
  }

  .weblog-details >>> img {
    height: auto !important;
  }
}

.bg-white {
  background-color: #ffffff73 !important;
}

.dis-post {
  overflow: hidden;
}
</style>
<style>
.dis-post * {
  color: #000 !important;
}
.dis-post li {
  list-style-position: inside !important;
}

.dis-post a {
  color: blue !important;
}

.dis-post
  *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6):not(h1 *):not(h2 *):not(h3
    *):not(h4 *):not(h5 *):not(h6 *) {
  font-size: 18px;
}
.dis-post header {
  width: 100% !important;
}

@media only screen and (max-width: 648px) {
  .dis-post
    *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6):not(h1 *):not(h2 *):not(h3
      *):not(h4 *):not(h5 *):not(h6 *) {
    font-size: 16px;
  }
}
</style>
